
import React, { useEffect, useState } from 'react';
import Breadcrumb from '../../Breadcrumb/Breadcrumb';
import usePermisos from '../../../hooks/usePermisos';
import axios from '../../../axios';
import Squares2X2Icon from '@heroicons/react/24/outline/Squares2X2Icon';
import { Table, useTableSort, useTablePagination, TableSwitch } from '../../UI';
import GruposProductosModal from './GruposProductosModal';

const PERMISOS_REQUERIDOS = [
    'products_read',
    'products_create',
    'products_update',
    'products_delete'
];

const Grupos = () => {
    const { permisos, loading: loadingPermisos, tienePermiso } = usePermisos(PERMISOS_REQUERIDOS);
    const [groups, setGroups] = useState([]);


    useEffect(() => {
        if (!loadingPermisos && tienePermiso('products_read')) {
            getGrupos();
        }
    }, [permisos]);

    const getGrupos = () => {
        axios.get('/api/product-groups')
            .then(res => {
                setGroups(res.data);
            })
            .catch(err => {
                console.error("Error al obtener grupos de productos", err);
            });
    };

    const _delete = (grupo) => {
        if (window.confirm("Realmente deseas borrar este grupo de productos, si lo borras no se podra recuperar despues")) {
            axios.delete(`/api/product-groups/${grupo.id}`)
                .then(() => {
                    getGrupos();
                })
                .catch(err => {
                    console.error("Error al borrar grupo de productos", err);
                });
        }
    };

    // Estado para modal de sincronización
    const [grupoSelected, setGrupoSelected] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);

    // Handler para cambiar el estado activo/inactivo
    const [loadingId, setLoadingId] = useState(null);
    const handleToggleActive = async (newValue, row) => {
        setLoadingId(row.id);
        try {
            await axios.put(`/api/product-groups/${row.id}`, { active: newValue });
            getGrupos();
        } catch (err) {
            console.error('Error al actualizar estado activo', err);
        } finally {
            setLoadingId(null);
        }
    };

    // Configuración de columnas para la tabla
    const columns = [
        {
            key: 'name',
            label: 'Nombre',
            sortable: true,
        },
        {
            key: 'description',
            label: 'Descripción',
            sortable: false,
        },
        {
            key: 'products',
            label: 'Productos',
            render: (value, row) => value?.length || 0,
        },
        {
            key: 'active',
            label: 'Activo',
            align: 'center',
            render: (value, row) => (
                <TableSwitch
                    value={!!value}
                    onChange={(val) => handleToggleActive(val, row)}
                    row={row}
                    loading={loadingId === row.id}
                />
            ),
        },
        {
            key: 'sync',
            label: 'Sincronizar Productos',
            align: 'center',
            render: (_, row) => (
                <button
                    className="btn btn-sm btn-primary"
                    onClick={() => {
                        setGrupoSelected(row);
                        setModalOpen(true);
                    }}
                >
                    Sincronizar
                </button>
            ),
        },
        {
            key: 'created_at',
            label: 'Creado',
            sortable: true,
            render: (value) => value ? new Date(value).toLocaleDateString() : '-',
        },
    ];

     // Configuración de acciones
    const actions = [
        {
            type: 'edit',
            to: (row) => `${row.id}`,
            tooltip: 'Editar',
            permission: 'products_update',
        },
        {
            type: 'delete',
            onClick: _delete,
            tooltip: 'Eliminar',
            permission: 'products_delete',
        },
    ];

    // Hooks para sorting y paginación
    const { sortedData, sortConfig, handleSort } = useTableSort(groups);
    const {
        paginatedData,
        page,
        setPage,
        itemsPerPage,
        setItemsPerPage,
        totalItems
    } = useTablePagination(sortedData, { page: 1, itemsPerPage: 10 });

    return (
        <>
            <div className='container-admin-menu'>
                <Breadcrumb hasButton={tienePermiso('products_create')} hasFilters={false} />
            </div>
            <div className='container-admin-container'>
                <div className='container-admin z-depth-1 p-4'>
                    <h5 className="pb-4 text-xl font-bold flex items-center justify-start">
                        <Squares2X2Icon className="inline-block h-6 w-6 mr-2" /> Caterogarias Web
                    </h5>
                    <Table
                        columns={columns}
                        data={paginatedData}
                        actions={actions}
                        permissions={permisos}
                        loading={loadingPermisos}
                        striped={true}
                        hoverable={true}
                        emptyMessage="No hay grupos registrados"
                        sorting={{
                            field: sortConfig.field,
                            direction: sortConfig.direction,
                            onSort: handleSort
                        }}
                        pagination={{
                            page,
                            itemsPerPage,
                            totalItems,
                            onPageChange: setPage,
                            onItemsPerPageChange: setItemsPerPage
                        }}
                    />
                    <GruposProductosModal
                        isOpen={modalOpen}
                        onClose={() => setModalOpen(false)}
                        grupo={grupoSelected}
                        setUpdated={getGrupos}
                    />
                </div>
            </div>
        </>
    );
};

export default Grupos;